<div class="fade modal modal-static pg-show-modal modal-timetable-edit" id="modal-employee-substitution" tabindex="-1"
  role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-dialog-centered modal-sm">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Disponibilidad para reemplazos</h4>
        <button (click)="onCancel($event)" type="button" class="close" data-dismiss="modal" aria-hidden="true"
          title="Cerrar modal">&times;</button>
      </div>

      <div class="modal-body">
        <form role="form" action="#" method="post" [formGroup]="_formGroupModal">
          <div id="form-carousel-employee-substitution" class="carousel slide">
            <div class="carousel-inner transition-carousel-inner">
              <div class="carousel-item active">
                <div class="table-responsive">

                  <table [formGroup]="_formGroupModal"
                    class="font-size-12 table table-body-lateral-th-400 table-borderless table-sm text-center time-table">
                    <thead>
                      <tr>
                        <th></th>
                        <th>Lunes</th>
                        <th>Martes</th>
                        <th>Miércoles</th>
                        <th>Jueves</th>
                        <th>Viernes</th>
                      </tr>
                    </thead>
                    <tbody class="checkbox-group">
                      <tr>
                        <th scope="row">Todo el día
                        </th>
                        <td>
                          <label class="checkbox-label no-label-text">
                            <input type="checkbox" [checked]="selectionAllMon"
                              (change)="onCheckChangeDay($event,'mon')">
                            <span class="checkmark"></span>
                          </label>
                        </td>
                        <td>
                          <label class="checkbox-label no-label-text">
                            <input type="checkbox" [checked]="selectionAllTue"
                              (change)="onCheckChangeDay($event,'tue')">
                            <span class="checkmark"></span>
                          </label>
                        </td>
                        <td>
                          <label class="checkbox-label no-label-text">
                            <input type="checkbox" [checked]="selectionAllWed"
                              (change)="onCheckChangeDay($event,'wed')">
                            <span class="checkmark"></span>
                          </label>
                        </td>
                        <td>
                          <label class="checkbox-label no-label-text">
                            <input type="checkbox" [checked]="selectionAllThu"
                              (change)="onCheckChangeDay($event,'thu')">
                            <span class="checkmark"></span>
                          </label>
                        </td>
                        <td>
                          <label class="checkbox-label no-label-text">
                            <input type="checkbox" [checked]="selectionAllFri"
                              (change)="onCheckChangeDay($event,'fri')">
                            <span class="checkmark"></span>
                          </label>
                        </td>
                      </tr>
                      <tr *ngFor="let hour of hourSubstitutionMon.controls; let i = index">
                        <th scope="row">{{arrayHourSubstitution.mon[i].label}}
                        </th>
                        <td>
                          <label formArrayName="hourSubstitutionMon" class="checkbox-label no-label-text">
                            <input type="checkbox" [formControlName]="i">
                            <span class="checkmark"></span>
                          </label>
                        </td>
                        <td>
                          <label formArrayName="hourSubstitutionTue" class="checkbox-label no-label-text">
                            <input type="checkbox" [formControlName]="i">
                            <span class="checkmark"></span>
                          </label>
                        </td>
                        <td>
                          <label formArrayName="hourSubstitutionWed" class="checkbox-label no-label-text">
                            <input type="checkbox" [formControlName]="i">
                            <span class="checkmark"></span>
                          </label>
                        </td>
                        <td>
                          <label formArrayName="hourSubstitutionThu" class="checkbox-label no-label-text">
                            <input type="checkbox" [formControlName]="i">
                            <span class="checkmark"></span>
                          </label>
                        </td>
                        <td>
                          <label formArrayName="hourSubstitutionFri" class="checkbox-label no-label-text">
                            <input type="checkbox" [formControlName]="i">
                            <span class="checkmark"></span>
                          </label>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                </div>
                <div class="form-row">
                  <div class="col-12 text-center space-items-10">
                    <button (click)="onCancel($event)" class="btn btn-outline-primary" type="button"
                      data-dismiss="modal">Cancelar</button>

                    <button class="btn btn-primary" (click)="onClickSubmitButton($event)"
                      [attr.disabled]="isButtonSubmitEnabled === true ? null : true">Guardar</button>

                  </div>
                </div>
              </div>
              <div class="carousel-item successSlide">
                <div class="mgn-bottom-25 row">
                  <div class="col-12 text-center"><i
                      class="blue-ligth-1 d-inline-block mgn-bottom-15 pj-ico pj-ico-modal-ok"></i>
                    <p class="mgn-bottom-25 text-dark">Los datos fueron guardados exitosamente.</p>
                  </div>
                </div>
                <div class="form-row">
                  <div class="col-12 text-center"><a class="btn btn-primary" href="#" data-dismiss="modal">Cerrar</a>
                  </div>
                </div>
              </div>
              <div class="carousel-item errorSlide">
                <div class="mgn-bottom-25 row">
                  <div class="col-12 text-center"><i
                      class="blue-ligth-1 d-inline-block mgn-bottom-15 pj-ico pj-ico-modal-error"></i>
                    <h4 class="error-alert-heading text-primary">Lo sentimos, ha ocurrido un error
                    </h4>
                    <p class="mgn-bottom-25 text-dark">Presione el botón “Volver a intentar” para
                      intentarlo otra vez de lo contrario presione “Cerrar” para salir de esta
                      ventana.</p>
                  </div>
                </div>
                <div class="form-row">
                  <div class="col-12 text-center space-items-15">
                    <button class="btn btn-outline-primary" data-dismiss="modal" type="button"
                      (click)="onCancel($event)">Cancelar</button>
                    <button class="btn btn-primary" (click)="resetStepCarousel()" type="button">Volver a
                      intentar</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>